export const a11yProps = (name: string, index: number) => {
  return {
    id: `${name}-${index}`,
    'aria-controls': `${name}panel-${index}`,
  };
};
